import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { CircularProgress, Box } from "@mui/material";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireManager?: boolean;
  requireAdmin?: boolean;
}

export function ProtectedRoute({
  children,
  requireManager = false,
  requireAdmin = false,
}: ProtectedRouteProps) {
  const { isAuthenticated, isManager, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requireManager && !isManager) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
